import { For, createSignal } from "solid-js";
import * as styles from "./css/Crosshair.module.css";
const CrossHair = () => {
    const [amount] = createSignal(2);
    return (<span class={styles.crosshair}>
            <For each={Array.from(Array(amount()))}>
                {(_, index) => (<span class={styles.crosshairPart} style={{
                rotate: `${index() * 90}deg`,
            }}/>)}
            </For>
        </span>);
};
export default CrossHair;
